export default __webpack_public_path__ + "static/media/draw_white.ba73f553.svg";